import { Action } from '@ngrx/store';

export enum JobCardActionTypes {
  LoadJobCard = '[JobCard] Load JobCard',
  JobCardLoaded = '[JobCard] JobCard Loaded',
  JobCardLoadError = '[JobCard] JobCard Load Error',
  LoadSelectedJobCard = '[JobCard] Load Selected Job Card',
  SelectedJobCardLoaded = '[JobCard] Selected Job Card Loaded',
  SelectedJobCardLoadError = '[JobCard] Selected Job Card Load Error',
  CreateJobCard = '[JobCard] Create Job Card',
  CreateJobCardError = '[JobCard] Create Job Card Error',
  JobCardCreated = '[JobCard] Job Card Created',
  NextJobNoUpdated = '[JobCard] Next Job Card No Updated',
  NextJobNoUpdatedError = '[JobCard] Next Job Card No Updated Error',
  LoadNextJobNo = '[JobCard] Load Next Job No',
  NextJobNoLoaded = '[JobCard] Next Job No Loaded',
  LoadNextJobNoError = '[JobCard] Load Next Job No Error',
  UpdateJObCard = '[JobCard] Update Job Card',
  JobCardUpdated = '[JobCard] Job Card Updated',
  UpdateJobCardError = '[JobCard] Update Job Card Error',
  SaveStuffingDetails = '[JobCard] Save Stuffing Details',
  SaveLoadingConfirmationDetails = '[JobCard] Save Loading Confirmation Details',
  SaveTVTBLDetails = '[JobCard] Save TVT BL Details',
  SaveEGLBLDetails = '[JobCard] Save EGL BL Details',
  SaveAWBDetails = '[JobCard] Save AWB Details',
  AWBDetailsSaved = '[JobCard] AWB Details Saved',
  SaveAWBDetailsError = '[JobCard] Save AWB Details Error',
  LoadAWBDetails = '[JobCard] Load AWB Details',
  AWBDetailsLoaded = '[JobCard] AWB Details Loaded',
  LoadAWBDetailsError = '[JobCard] Load AWB Details Error',
  UpdateAWBDetails = '[JobCard] Update AWB Details',
  AWBDetailsUpdated = '[JobCard] AWB Details Updated',
  UpdateAWBDetailsError = '[JobCard] Update AWB Details Error',
  SaveACDDetails = '[JobCard] Save ACD Details',
  UploadFiles = '[JobCard] Upload Files',
  FilesUploaded = '[JobCard] Files Uploaded',
  FileUploadError = '[JobCard] File Upload Error',
  LoadFiles = '[JobCard] Load Files',
  FilesLoaded = '[JobCard] Files Loaded',
  FilesLoadError = '[JobCard] Files Load Error',
  FilesProgress = '[JobCard] File Progress',
}

export class LoadJobCard implements Action {
  readonly type = JobCardActionTypes.LoadJobCard;
  constructor(public filter?: string, public filterByMode?: string) {}
}

export class JobCardLoadError implements Action {
  readonly type = JobCardActionTypes.JobCardLoadError;
  constructor(public payload: any) {}
}

export class JobCardLoaded implements Action {
  readonly type = JobCardActionTypes.JobCardLoaded;
  constructor(public payload: any) {}
}

export class LoadSelectedJobCard implements Action {
  readonly type = JobCardActionTypes.LoadSelectedJobCard;
  constructor(public payload: string, public date: string) {}
}

export class SelectedJobCardLoadError implements Action {
  readonly type = JobCardActionTypes.SelectedJobCardLoadError;
  constructor(public payload: any) {}
}

export class SelectedJobCardLoaded implements Action {
  readonly type = JobCardActionTypes.SelectedJobCardLoaded;
  constructor(public payload: any) {}
}

export class CreateJobCard implements Action {
  readonly type = JobCardActionTypes.CreateJobCard;
  constructor(public payload: any) {}
}

export class CreateJobCardError implements Action {
  readonly type = JobCardActionTypes.CreateJobCardError;
  constructor(public payload: any) {}
}

export class JobCardCreated implements Action {
  readonly type = JobCardActionTypes.JobCardCreated;
  constructor(public payload: any) {}
}

export class NextJobNoUpdated implements Action {
  readonly type = JobCardActionTypes.NextJobNoUpdated;
  constructor(public payload: any) {}
}

export class NextJobNoUpdatedError implements Action {
  readonly type = JobCardActionTypes.NextJobNoUpdatedError;
  constructor(public payload: any) {}
}

export class LoadNextJobNo implements Action {
  readonly type = JobCardActionTypes.LoadNextJobNo;
}

export class NextJobNoLoaded implements Action {
  readonly type = JobCardActionTypes.NextJobNoLoaded;
  constructor(public payload: any) {}
}

export class LoadNextJobNoError implements Action {
  readonly type = JobCardActionTypes.LoadNextJobNoError;
  constructor(public payload: any) {}
}

export class UpdateJObCard implements Action {
  readonly type = JobCardActionTypes.UpdateJObCard;
  constructor(
    public payload: any,
    public onTransfer?: boolean,
    public email?: string
  ) {}
}

export class JobCardUpdated implements Action {
  readonly type = JobCardActionTypes.JobCardUpdated;
  constructor(public payload: any) {}
}

export class UpdateJobCardError implements Action {
  readonly type = JobCardActionTypes.UpdateJobCardError;
  constructor(public payload: any) {}
}

export class SaveStuffingDetails implements Action {
  readonly type = JobCardActionTypes.SaveStuffingDetails;
  constructor(public payload: any) {}
}

export class SaveLoadingConfirmationDetails implements Action {
  readonly type = JobCardActionTypes.SaveLoadingConfirmationDetails;
  constructor(public payload: any) {}
}

export class SaveTVTBLDetails implements Action {
  readonly type = JobCardActionTypes.SaveTVTBLDetails;
  constructor(public payload: any) {}
}

export class SaveEGLBLDetails implements Action {
  readonly type = JobCardActionTypes.SaveEGLBLDetails;
  constructor(public payload: any) {}
}

export class SaveAWBDetails implements Action {
  readonly type = JobCardActionTypes.SaveAWBDetails;
  constructor(public payload: any, public id?: string) {}
}

export class AWBDetailsSaved implements Action {
  readonly type = JobCardActionTypes.AWBDetailsSaved;
  constructor(public payload: any, public logoUrl?: any) {}
}

export class SaveAWBDetailsError implements Action {
  readonly type = JobCardActionTypes.SaveAWBDetailsError;
  constructor(public payload: any) {}
}

export class LoadAWBDetails implements Action {
  readonly type = JobCardActionTypes.LoadAWBDetails;
  constructor(public id: string) {}
}

export class AWBDetailsLoaded implements Action {
  readonly type = JobCardActionTypes.AWBDetailsLoaded;
  constructor(public payload: any) {}
}

export class LoadAWBDetailsError implements Action {
  readonly type = JobCardActionTypes.LoadAWBDetailsError;
  constructor(public payload: any) {}
}

export class UpdateAWBDetails implements Action {
  readonly type = JobCardActionTypes.UpdateAWBDetails;
  constructor(public payload: any) {}
}

export class AWBDetailsUpdated implements Action {
  readonly type = JobCardActionTypes.AWBDetailsUpdated;
  constructor(public payload: any) {}
}

export class UpdateAWBDetailsError implements Action {
  readonly type = JobCardActionTypes.UpdateAWBDetailsError;
  constructor(public payload: any) {}
}

export class SaveACDDetails implements Action {
  readonly type = JobCardActionTypes.SaveACDDetails;
  constructor(public payload: any) {}
}

export class UploadFiles implements Action {
  readonly type = JobCardActionTypes.UploadFiles;
  constructor(public fileName: string, public files: File) {}
}

export class FilesUploaded implements Action {
  readonly type = JobCardActionTypes.FilesUploaded;
}

export class FileUploadError implements Action {
  readonly type = JobCardActionTypes.FileUploadError;
}

export class LoadFiles implements Action {
  readonly type = JobCardActionTypes.LoadFiles;
  constructor(public prefix: string) {}
}
export class FilesLoaded implements Action {
  readonly type = JobCardActionTypes.FilesLoaded;
  constructor(public files: any[]) {}
}

export class FilesLoadError implements Action {
  readonly type = JobCardActionTypes.FilesLoadError;
}

export class FilesProgress implements Action {
  readonly type = JobCardActionTypes.FilesProgress;
  constructor(public payload: any) {}
}

export type JobCardAction =
  | LoadJobCard
  | JobCardLoaded
  | JobCardLoadError
  | LoadSelectedJobCard
  | SelectedJobCardLoadError
  | SelectedJobCardLoaded
  | CreateJobCard
  | CreateJobCardError
  | JobCardCreated
  | NextJobNoUpdated
  | NextJobNoUpdatedError
  | LoadNextJobNo
  | NextJobNoLoaded
  | LoadNextJobNoError
  | UpdateJObCard
  | JobCardUpdated
  | UpdateJobCardError
  | SaveStuffingDetails
  | SaveLoadingConfirmationDetails
  | SaveTVTBLDetails
  | SaveEGLBLDetails
  | SaveAWBDetails
  | AWBDetailsSaved
  | SaveAWBDetailsError
  | LoadAWBDetails
  | AWBDetailsLoaded
  | LoadAWBDetailsError
  | UpdateAWBDetails
  | AWBDetailsUpdated
  | UpdateAWBDetailsError
  | SaveACDDetails
  | UploadFiles
  | FilesUploaded
  | FileUploadError
  | LoadFiles
  | FilesLoaded
  | FilesLoadError
  | FilesProgress;

export const fromJobCardActions = {
  LoadJobCard,
  JobCardLoaded,
  JobCardLoadError,
  LoadSelectedJobCard,
  SelectedJobCardLoadError,
  SelectedJobCardLoaded,
  CreateJobCard,
  CreateJobCardError,
  JobCardCreated,
  NextJobNoUpdated,
  NextJobNoUpdatedError,
  LoadNextJobNo,
  NextJobNoLoaded,
  LoadNextJobNoError,
  UpdateJObCard,
  JobCardUpdated,
  UpdateJobCardError,
  SaveStuffingDetails,
  SaveLoadingConfirmationDetails,
  SaveTVTBLDetails,
  SaveEGLBLDetails,
  SaveAWBDetails,
  AWBDetailsSaved,
  SaveAWBDetailsError,
  LoadAWBDetails,
  AWBDetailsLoaded,
  LoadAWBDetailsError,
  UpdateAWBDetails,
  AWBDetailsUpdated,
  UpdateAWBDetailsError,
  SaveACDDetails,
  UploadFiles,
  FilesUploaded,
  FileUploadError,
  LoadFiles,
  FilesLoaded,
  FilesLoadError,
  FilesProgress,
};
